class YoutubeVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const videoId = this.dataset.videoId
    if (!videoId) return

    this.render(videoId)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.MODAL.CLOSED,
      (e) => {
        if (e.detail.id !== this.dataset.modalId) return
        this.reset()
      },
    )
  }

  render (videoId) {
    const poster = document.createElement('img')
    poster.className = 'vd-YoutubeVideo_Poster'
    poster.alt = ''
    poster.loading = 'lazy'
    poster.width = 1280
    poster.height = 720

    const probe = new Image()
    probe.src = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`
    probe.onload = () => {
      poster.src =
        probe.naturalWidth === 120
          ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
          : probe.src
    }

    const overlay = document.createElement('button')
    overlay.className = 'vd-YoutubeVideo_Overlay'
    overlay.setAttribute('aria-label', 'Play video')
    overlay.type = 'button'
    overlay.innerHTML = `
      <span class="vd-YoutubeVideo_Play btn-Video btn-Video-cta" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path fill="currentColor" d="M16.933 11.2a1 1 0 0 1 0 1.6l-9.333 7A1 1 0 0 1 6 19V5a1 1 0 0 1 1.6-.8z"/>
        </svg>
      </span>
    `

    this.appendChild(poster)
    this.appendChild(overlay)

    overlay.addEventListener('click', () => this.activate(videoId), {
      once: true,
    })
  }

  activate (videoId) {
    const iframe = document.createElement('iframe')
    iframe.className = 'vd-YoutubeVideo_Iframe'
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
    iframe.allowFullscreen = true
    iframe.title = 'YouTube video'

    const overlay = this.querySelector('.vd-YoutubeVideo_Overlay')
    if (overlay) overlay.remove()

    this.appendChild(iframe)
    this.classList.add('vd-YoutubeVideo_Embed-active')
  }

  reset () {
    const iframe = this.querySelector('iframe')
    if (!iframe) return

    iframe.remove()
    this.classList.remove('vd-YoutubeVideo_Embed-active')

    const videoId = this.dataset.videoId
    const overlay = document.createElement('button')
    overlay.className = 'vd-YoutubeVideo_Overlay'
    overlay.setAttribute('aria-label', 'Play video')
    overlay.type = 'button'
    overlay.innerHTML = `
      <span class="vd-YoutubeVideo_Play btn-Video btn-Video-cta" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path fill="currentColor" d="M16.933 11.2a1 1 0 0 1 0 1.6l-9.333 7A1 1 0 0 1 6 19V5a1 1 0 0 1 1.6-.8z"/>
        </svg>
      </span>
    `
    overlay.addEventListener('click', () => this.activate(videoId), {
      once: true,
    })
    this.appendChild(overlay)
  }
}

if (!customElements.get('youtube-video')) {
  customElements.define('youtube-video', YoutubeVideo)
}
